import type { HistoryEventDirection } from "../../types";

export const BLOCKED_LABEL_KEYS: Record<HistoryEventDirection, string> = {
  undo: "smartSurveyor.history.cannotUndo",
  redo: "smartSurveyor.history.cannotRedo",
};
